import { render, staticRenderFns } from "./address-manager.vue?vue&type=template&id=657055c0&scoped=true"
import script from "./address-manager.vue?vue&type=script&lang=js"
export * from "./address-manager.vue?vue&type=script&lang=js"
import style0 from "./address-manager.vue?vue&type=style&index=0&id=657055c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657055c0",
  null
  
)

export default component.exports